import { render, staticRenderFns } from "./OtherIncome.vue?vue&type=template&id=fddbdcbc&scoped=true&"
import script from "./OtherIncome.vue?vue&type=script&lang=js&"
export * from "./OtherIncome.vue?vue&type=script&lang=js&"
import style0 from "./OtherIncome.vue?vue&type=style&index=0&id=fddbdcbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddbdcbc",
  null
  
)

export default component.exports